const data={"info":<>
<h1 style={{fontSize:"1.8rem",fontWeight:"600",textAlign:"left"}}>Sheetal Bijalwan</h1> 
<div className="d-flex justify-content-center align-items-center pratha" style={{gap:"5rem"}} >

<div className="right-box-info">

<br/>
<ul className="pra-det">
    <li>Associate Editor-in-Chief, UPES-CSI</li>
    <li>
        Supporting editorial initiatives.
    </li>
    <li>
        Maintaining high standards in content creation.
    </li>
</ul>
</div>
</div>
</>
}

export default data;
